var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 3H27L42 18V40.2C42 42.851 39.851 45 37.2 45H10.8C8.14904 45 6 42.851 6 40.2V7.8C6 5.14903 8.14903 3 10.8 3ZM37.2 41.25H10.8C10.2201 41.25 9.75 40.7799 9.75 40.2V7.8C9.75 7.2201 10.2201 6.75 10.8 6.75H24.5244V15.0012C24.5244 18.0249 26.9757 20.4762 29.9994 20.4762H38.25V40.2C38.25 40.7799 37.7799 41.25 37.2 41.25ZM35.4229 16.7262L28.2744 9.57771V15.0012C28.2744 15.9539 29.0467 16.7262 29.9994 16.7262H35.4229Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherDocument);
export default __webpack_public_path__ + "static/media/otherDocument.25f62c915eb9e66fe6a5578ac13a36c3.svg";
export { ForwardRef as ReactComponent };